import { Components, formHelperTextClasses, Theme } from '@mui/material';

export const MuiFormHelperText: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: ({ theme }) => {
      if (!theme.featureFlags.panwRebrandStubYear) return {};
      return {
        [`&.${formHelperTextClasses.error}`]: {
          color: theme.palette.input.errorColor,
        },
      };
    },
  },
};
